export const getPageNumbers = (totalPages: number = 1, currentPage: number = 1) => {
	const visiblePageNumbers = [];

	if (totalPages <= 7) {
		for (let i = 1; i <= totalPages; i++) {
			visiblePageNumbers.push(i);
		}
	} else {
		if (currentPage < 5) {
			visiblePageNumbers.push(1, 2, 3, 4, 5, 'dots', totalPages);
		} else if (currentPage >= totalPages - 3) {
			visiblePageNumbers.push(1, 'dots', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
		} else {
			visiblePageNumbers.push(1, 'dots', currentPage - 1, currentPage, currentPage + 1, 'dots', totalPages);
		}
	}

	return visiblePageNumbers;
};
